import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'

export const useAccountUserDomainMutation = domain => {
  const godModeState = getGodModeOptionsState()

  return useGenericRequestHandler({
    route: `t/${domain}`,
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  })
}
